module.exports = __webpack_public_path__ + "static/media/mockupIcon.ff5529c6.svg";